<template>
	<div>
		<h3 class="popup-tilte" v-if="!getIsSimpleRegistration">Bejelentkezés</h3>
        <h3 class="popup-tilte" v-if="getIsSimpleRegistration">Egyszerűsített regisztráció</h3>
		<Login
			registrationComponent="ContractingRegistration"
			@success="handleSuccess"
			registrationText="Regisztráció"
            v-if="!getIsSimpleRegistration"
		/>
        <simple-registration v-if="getIsSimpleRegistration" @success="handleSuccess"/>
	</div>
</template>

<script>
import Login from '@/components/Login.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import SimpleRegistration from "@/components/SimpleRegistration.vue";

export default {
	components: {
        SimpleRegistration,
		Login,
	},
	computed: {
        ...mapGetters('auth',['getIsSimpleRegistration']),
        ...mapGetters(['getIsBusinessProcess']),
		...mapGetters('contracting', ['getSelectedOffer']),
	},
	methods: {
        ...mapActions('contracting',['fetchContract']),
		...mapMutations(['popupHasClose']),
		...mapActions(['updateUserId']),
		async handleSuccess() {
            if(!this.getIsBusinessProcess) {
			    await this.updateUserId();
            }
			this.popupHasClose(true);
			if (this.$route.name !== 'contracting-base') {
                if(this.getIsBusinessProcess){
                    await this.fetchContract({hash: this.$route.params.hash});
                } else{
                    this.$router.push({
                        name: 'contracting-base',
                        params: {
                            hash: this.$route.params.hash,
                            insurer_uuid: this.getSelectedOffer.insurer_uuid,
                        },
                    });
                }
			}
		},
	},
};
</script>
